









import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

import {FbPost} from '@app/store/models/FbPost';

@Component
export default class CubNewsItem extends Vue {
    @Prop() public post: FbPost;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/home/news-feed/NewsItem.vue